module.exports = __webpack_public_path__ + "static/media/E1757039-A9A2-4E96-9021-F07B07D8F708-min.e0a740b1.jpg";